<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jxky/home">教学科研</router-link> >
      <router-link to="/jxky/byhyxjy">毕业后医学教育</router-link> >
      <router-link to="/jxky/professional">专业基地</router-link> >
      {{ current.keyword }}
    </div>
    <div class="container-width">
      <ARTICLE
        :current="current"
        :before="before"
        :after="after"
        :showBeforeAfter="showBeforeAfter"
        :showorigin="showorigin"
      ></ARTICLE>
    </div>
  </div>
</template>
<script>
import service from "../../service/jxky";
import BANNER from "../../components/banner/jxky";
import { jxkyNavDic } from "../../const/navigationData";
export default {
  name: "PROFESSIONALARTICLE",
  data() {
    return {
      navigationData: jxkyNavDic,
      currentPath: "/jxky/byhyxjy",
      current: {
        title: "",
        description: "",
        releaseDate: "",
        views: "",
        origin: "",
      },
      // 上一篇
      before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showBeforeAfter: false, //是否显示上一篇 下一篇
      showorigin: false, //是否显示来源 发布时间 点击次数
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let data = {
        id: this.$route.params.id,
      };
      service.getOneProfessionalBase(data, (res) => {
        // console.log("res", res);
        this.current = res.object || {};
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
</style>
